import { Box, Typography } from "@mui/material";
import { renderSubTitle } from "../../../components/renderComponents";
import type { ExtractionImage } from "../../../types/extraction";
import { ExtractionImageCard } from "./ExtractionImageCard";

interface ExtractionAiClassificationProps {
  hero: ExtractionImage | null;
  selected: ExtractionImage[];
  onImageError?: (image: ExtractionImage) => void;
  selectionUpdating?: boolean;
  onToggleSelected?: (image: ExtractionImage) => void;
  onSetPrimary?: (image: ExtractionImage) => void;
}

export function ExtractionAiClassification({
  hero,
  selected,
  onImageError,
  selectionUpdating,
  onToggleSelected,
  onSetPrimary,
}: ExtractionAiClassificationProps) {
  const secondaries = selected.filter((img) => !img.is_hero);

  if (!hero && secondaries.length === 0) {
    return null;
  }

  const cardProps = {
    variant: "large" as const,
    onImageError,
    selectable: true,
    selectionUpdating,
    onToggleSelected,
    onSetPrimary,
  };

  return (
    <Box sx={{ mb: 3 }}>
      {renderSubTitle("AI Image Classification")}
      <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, mb: 1.5 }}>
        Review the AI&apos;s suggested images. Your selection is applied to the
        deal gallery when you create or update the deal.
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            md: hero ? "2fr 1fr" : "1fr",
          },
          gap: 2,
        }}
      >
        {hero && (
          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: "block" }}>
              Primary image
            </Typography>
            <ExtractionImageCard image={hero} {...cardProps} />
          </Box>
        )}
        {secondaries.length > 0 && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Typography variant="caption" color="text.secondary">
              Secondary images
            </Typography>
            {secondaries.map((img) => (
              <ExtractionImageCard key={img.id} image={img} {...cardProps} />
            ))}
          </Box>
        )}
      </Box>
    </Box>
  );
}

/** @deprecated Use ExtractionAiClassification */
export const ExtractionGptPicks = ExtractionAiClassification;
